(() => {
  document.querySelectorAll('[data-plus-hero-slider]').forEach((slider) => {
    const slides = [...slider.querySelectorAll('[data-plus-hero-slide]')];
    const dots = [...slider.querySelectorAll('[data-plus-hero-dot]')];
    const prev = slider.querySelector('[data-plus-hero-prev]');
    const next = slider.querySelector('[data-plus-hero-next]');
    const autoplay = Number(slider.dataset.autoplay || 0);
    let index = Math.max(0, slides.findIndex((slide) => slide.classList.contains('is-active')));
    let timer;
    let fitFrame;

    if (slides.length < 1) return;

    const fitViewport = () => {
      if (!slider.classList.contains('pcd-hero-slider--banners')) return;

      const viewport = slider.querySelector('.pcd-hero-slider__viewport');
      if (!viewport) return;

      const bottomGap = window.matchMedia('(max-width: 749px)').matches ? 12 : 18;
      const isMobile = window.matchMedia('(max-width: 749px)').matches;
      const isTablet = window.matchMedia('(max-width: 989px)').matches;
      const viewportRect = viewport.getBoundingClientRect();
      const viewportTop = Math.max(0, viewportRect.top);
      const availableHeight = Math.max(180, Math.floor(window.innerHeight - viewportTop - bottomGap));
      const aspectHeight = viewportRect.width * (isMobile ? 1.25 : 0.57142);
      const maxHeight = isMobile || isTablet ? 620 : 800;
      const fitHeight = Math.max(180, Math.floor(Math.min(aspectHeight, availableHeight, maxHeight)));

      viewport.style.height = `${fitHeight}px`;
      viewport.style.minHeight = `${fitHeight}px`;
      viewport.style.setProperty('--pcd-hero-available-height', `${fitHeight}px`);
    };

    const requestFitViewport = () => {
      cancelAnimationFrame(fitFrame);
      fitFrame = requestAnimationFrame(fitViewport);
    };

    const show = (target) => {
      index = (target + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => {
        slide.classList.toggle('is-active', slideIndex === index);
        slide.setAttribute('aria-hidden', String(slideIndex !== index));
      });
      dots.forEach((dot, dotIndex) => {
        dot.classList.toggle('is-active', dotIndex === index);
        dot.setAttribute('aria-current', dotIndex === index ? 'true' : 'false');
      });
    };

    const restart = () => {
      if (!autoplay || slides.length < 2) return;
      clearInterval(timer);
      timer = setInterval(() => show(index + 1), autoplay * 1000);
    };

    prev?.addEventListener('click', () => {
      show(index - 1);
      restart();
    });

    next?.addEventListener('click', () => {
      show(index + 1);
      restart();
    });

    dots.forEach((dot, dotIndex) => {
      dot.addEventListener('click', () => {
        show(dotIndex);
        restart();
      });
    });

    fitViewport();
    window.addEventListener('resize', requestFitViewport, { passive: true });
    window.addEventListener('orientationchange', requestFitViewport, { passive: true });
    window.addEventListener('load', requestFitViewport, { once: true });

    show(index);
    restart();
  });
})();
